import { render, staticRenderFns } from "./patientPortalNotePackage.vue?vue&type=template&id=44aca17e&"
import script from "./patientPortalNotePackage.vue?vue&type=script&lang=js&"
export * from "./patientPortalNotePackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports